"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHIFTED_RIGHT_REGEX = exports.SHIFTED_RIGHT_APPENDIX = exports.PINTURA_VERSION = void 0;
exports.PINTURA_VERSION = '8.74.0';
exports.SHIFTED_RIGHT_APPENDIX = '--SHIFTED_RIGHT';
exports.SHIFTED_RIGHT_REGEX = /--SHIFTED(_RIGHT)?/;